import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const createOrder = async (order) => {
  try {
    const token = getAuthToken();

    // console.log("order to be: ", order);

    // Transform products to include quantity instead of count
    const transformedOrder = {
      order: {
        ...order,
        address: {
          id: order.address,
        },
        amount: order.amount,
        products: order.products.map((product) => ({
          // ...product,
          _id: product.productId || product.product._id,
          name: product.name || product.product.name,
          price: product.price || product.product.price,
          description: product?.description,
          // category: Category A,
          quantity: product.count || product.quantity,
        })),
      },
    };

    // console.log("transformed order: ", transformedOrder);

    const response = await api.post(`/order/create`, transformedOrder, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (err) {
    // console.log("I'm the error: ", err);
    const errorMessage = err.response?.data?.error || "Failed to create order";
    throw errorMessage;
  }
};

// const getAllOrders = async () => {
//   try {
//     const token = getAuthToken();
//     let queryParams = "";
//     if (category) queryParams += `&category=${category}`;
//     if (minPrice) queryParams += `&minPrice=${minPrice}`;
//     if (maxPrice) queryParams += `&maxPrice=${maxPrice}`;
//     if (search) queryParams += `&search=${search}`;

//     const data = await api.get("/orders", {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return data.data;
//   } catch (err) {
//     throw err;
//   }
// };

/**
 * Builds query string from parameters object
 * @param {Object} params - Query parameters
 * @returns {string} - Formatted query string
 */
const buildQueryString = (params) => {
  const queryParams = new URLSearchParams();

  // Pagination
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  // Sorting
  if (params.sortBy) queryParams.append("sortBy", params.sortBy);
  if (params.order) queryParams.append("order", params.order);

  // Filters
  if (params.status) queryParams.append("status", params.status);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);
  if (params.minAmount) queryParams.append("minAmount", params.minAmount);
  if (params.maxAmount) queryParams.append("maxAmount", params.maxAmount);
  if (params.transactionId)
    queryParams.append("transactionId", params.transactionId);

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : "";
};

const getOrders = async (params = {}) => {
  try {
    const token = getAuthToken();
    const queryString = buildQueryString(params);
    const response = await api.get(`/orders${queryString}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getUserOrders = async (params = {}) => {
  try {
    const token = getAuthToken();
    const queryString = buildQueryString(params);
    const response = await api.get(`/orders/by-user${queryString}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("Response: ", response.data);
    return response.data;
  } catch (error) {
    // console.log("Error: ", error);
    throw error;
  }
};

// ***************************************
// GET ALL POSSIBLE ORDER STATUS  FOR ADMIN ONLY
// const getOrderStatus = async () => {
//   try {
//     const token = getAuthToken();
//     const data = await api.get("/orders/status-values", {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return data.data;
//   } catch (err) {
//     throw err;
//   }
// };
// UPDATE ORDER STATUS FOR ADMIN ONLY
const updateOrderStatus = async (orderId, status) => {
  try {
    const token = getAuthToken();
    const data = await api.put(
      `/order/${orderId}/status`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

// Fetch a single order by ID
const getOrderById = async (orderId) => {
  try {
    const token = getAuthToken();
    const response = await api.get(`/get-order/${orderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  createOrder,
  updateOrderStatus,
  getOrders,
  getUserOrders,
  // getOrderStatus,
  getOrderById,
};
